import axios from 'axios';

import { ApplicationWithRenterDto } from '@tallo/applications';

import { ApplicationBundleDto } from '../interfaces/application-bundle.interfaces';

class ApplicationsService {
  async getBundlesByRenterId(renterId: string) {
    const response = await axios.get<ApplicationBundleDto[]>(
      `investor-application/application-bundles/renter/${renterId}`,
    );

    return response.data;
  }

  async getApplicationsByBundleId(bundleId: string) {
    const response = await axios.get<ApplicationWithRenterDto[]>(
      `investor-application/application-bundle/${bundleId}/applications`,
    );

    return response.data;
  }

  async send(inquiryId: string) {
    return axios.post<ApplicationBundleDto[]>(`investor-application/${inquiryId}`);
  }

  async getReport(applicationId: string, productType: string) {
    return axios.get<string>(`investor-application/${applicationId}/report`, { params: { productType } });
  }

  async resend(applicationBundleId: string) {
    return axios.post<ApplicationBundleDto[]>(`investor-application/${applicationBundleId}/resend`);
  }

  async accept(applicationBundleId: string): Promise<ApplicationBundleDto> {
    const response = await axios.post<ApplicationBundleDto>(`investor-application/${applicationBundleId}/accept`);
    return response.data;
  }

  async decline(applicationBundleId: string): Promise<ApplicationBundleDto> {
    const response = await axios.post<ApplicationBundleDto>(`investor-application/${applicationBundleId}/decline`);
    return response.data;
  }
}

export default new ApplicationsService();
